<!-- 退款弹窗 -->
<template>
	<dialogBody @confirm="confirm" @cancel="cancel" ref="body">
		<template slot="title">退款</template>
		<div style="padding-top: 20px;">
			<div class="formContainer">
				<label><span class="required">*</span>密码验证</label>
				<input type="password" v-model.trim="verifyPassword" autocomplete="new-password" maxlength="100" placeholder="请输入登录密码" />
			</div>
			<div class="formContainer">
				<label><span class="required">*</span>退款金额</label>
				<input type="number" v-model="refundNum" min="0" placeholder="请输入退款金额" @keydown="keydownFloat($event)" />
				<span style="margin-left: 10px;">元</span>
			</div>
		</div>
	</dialogBody>
</template>

<script>
	import dialogBody from '@/components/module/dialog/dialogBody.vue'
	export default {
		components: {
			dialogBody
		},
		props: {
			
		},
		data() {
			return {
				callback: undefined,
				verifyPassword: '',
				refundNum: 0,
			}
		},
		computed: {
			
		},
		watch: {},
		mounted() {},
		methods: {
			confirm() {
				if(this.verifyPassword == '' || this.verifyPassword == undefined){
					this.$dialogMethod.showMessage('必填项不可为空')
					return
				//}else if(isNaN(parseFloat(this.refundNum)) || (this.refundNum.indexOf('.') > 0 && this.refundNum.split('.')[1].length > 2)){
				}else if(parseFloat(this.refundNum) <= 0){
					this.$dialogMethod.showMessage('退款金额不能为0')
					return
				}
				if(this.callback != undefined){
					this.callback({password:hex_md5(this.verifyPassword), fee:parseFloat(this.refundNum * 100)})
				}
				this.close()
			},
			cancel() {
				this.close()
			},
			close() {
				this.verifyPassword = ''
				this.refundNum = 0
				this.$refs.body.hide()
			},
			open(callBack) {
				this.callback = callBack
				this.$refs.body.open()
			},
			keydownFloat(ev) {
				if(ev.keyCode == 109 || ev.keyCode == 229){
					ev.preventDefault()
				}
			},
		}
	}
</script>
<style scoped>
	.formContainer{
		margin-bottom: 12px;
	}
	
	.formContainer>label{
		min-width: 72px;
		text-align: right;
		display: inline-block;
		margin-right: 12px;
		line-height: 32px;
	}
	
	.formContainer>label>span{
		display: inline-block;
		width: 8px;
	}
	
	.required{
		color: red;
	}
	
	.balance{
		text-align: right;
	}
	.balance>span{
		color: #FF9900;
		font-size: .18rem;
		font-weight: bold;
	}
</style>